/**
 * check if video has premiered or not
 * @param {*} date - Date that video is supposed to premiere
 * @param {*} timezoneAbbrev - Timezone abbreviation selected
 * @returns status of if video has premiered or not
 */
const validateExpirationDate = (date) => {
    if (!date) {
        return false;
    };
    const today = new Date();
    const premiere = new Date(date);
    return new Date(today).getTime() < new Date(premiere).getTime();
};

export { validateExpirationDate };